import { EnergyBar, MicIndicator } from '../../../shared/components/EnergyBar'
import { RebusStage } from './RebusStage'
import { ConfirmedSegment } from '../../../shared/labs/transcript'

// Active rebus play screen: the picture stage with the energy bar between picture and
// transcript, and Commit/Pass underneath. Mirrors the cryptic/24 play views.
export const RebusView = ({
  puzzleId,
  energy,
  speaking,
  dimmed,
  confirmedSegments,
  interimText,
  progressLabel,
  showNudge,
  regime,
  onCommit,
  onPass,
}: {
  puzzleId: string
  energy: number
  speaking: boolean
  dimmed: boolean
  confirmedSegments: ConfirmedSegment[]
  interimText: string
  progressLabel?: string
  showNudge?: boolean
  regime: 'A' | 'B'
  onCommit: () => void
  onPass: () => void
}) => (
  <RebusStage
    puzzleId={puzzleId}
    dimmed={dimmed}
    confirmedSegments={confirmedSegments}
    interimText={interimText}
    progressLabel={progressLabel}
    showNudge={showNudge}
    regime={regime}
    middle={
      regime === 'A' ? (
        <EnergyBar energy={energy} speaking={speaking} dimmed={dimmed} />
      ) : (
        <MicIndicator speaking={speaking} />
      )
    }
  >
    <button
      type="button"
      onClick={onCommit}
      className="w-full rounded-lg bg-[#398874] py-3 text-white font-semibold leading-tight"
    >
      Commit answer
      <br />
      <span className="text-sm font-normal opacity-90">(or just say “commit”)</span>
    </button>
    <button
      type="button"
      onClick={onPass}
      className="mt-2 w-full rounded-lg border border-gray-200 py-2 text-sm font-medium text-gray-400 hover:bg-gray-50"
    >
      Pass
    </button>
    <p className="mt-2 text-center text-xs text-gray-400">You decide when to commit — up to 3 minutes per puzzle.</p>
  </RebusStage>
)
